export const ROUTES_PATH = {
  SCAI: "/scai",
  ROUTE: "/",
  MY_PROFILE: "/my-profile",
};
